// extracted by mini-css-extract-plugin
module.exports = {"container-header-recibos":"HeaderLigaPago_container-header-recibos__1A7Xt","logo-inter-recibos":"HeaderLigaPago_logo-inter-recibos__2zuW-"};